<template>
  <v-container>
    <v-row class="mb-n6">
      <v-col>
        <v-btn
          class="btn-primary"
          @click="createPage()"
        >
          <v-icon>mdi-plus</v-icon>
        </v-btn>
      </v-col>
      <v-col>
        <v-menu
          v-model="start_menu"
          :close-on-content-click="true"
          :nudge-right="40"
          transition="scale-transition"
          offset-y
          min-width="auto"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              v-model="start_date"
              label="ເລີ່ມວັນທີ"
              readonly
              outlined
              v-bind="attrs"
              dense
              clearable
              v-on="on"
            />
          </template>
          <v-date-picker v-model="start_date" />
        </v-menu>
      </v-col>
      <v-col>
        <v-menu
          v-model="end_menu"
          :close-on-content-click="true"
          :nudge-right="40"
          transition="scale-transition"
          offset-y
          min-width="auto"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              v-model="end_date"
              label="ຫາວັນທີ"
              readonly
              outlined
              v-bind="attrs"
              dense
              clearable
              v-on="on"
            />
          </template>
          <v-date-picker v-model="end_date" />
        </v-menu>
      </v-col>

      <v-col>
        <v-autocomplete
          v-model="selectedDistrict"
          outlined
          dense
          :items="districts"
          item-text="name"
          item-value="id"
          label="ເມືອງ"
          clearable
        />
      </v-col>
      <v-col>
        <v-autocomplete
          v-model="selectedVillage"
          outlined
          dense
          :items="villages"
          item-text="name"
          item-value="id"
          label="ບ້ານ"
          multiple
          clearable
        />
      </v-col>
      <v-col>
        <v-select
          v-model="selectedStatus"
          outlined
          dense
          :items="status"
          item-text="name"
          item-value="name"
          label="ສະຖານະ"
          multiple
          clearable
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-select
          v-model="selectedCustomerStatus"
          outlined
          dense
          :items="customerStatus"
          item-text="name"
          item-value="value"
          label="ສະຖານະແຜນ"
          multiple
          clearable
        />
      </v-col>
      <v-col>
        <v-select
          v-model="selectedCanCollect"
          outlined
          dense
          :items="can_collects"
          item-text="name"
          item-value="value"
          label="ເກັບເລີຍໄດ້ບໍ່"
          clearable
        />
      </v-col>

      <v-col>
        <v-select
          v-model="selectedCost"
          outlined
          dense
          :items="costs"
          item-text="name"
          item-value="value"
          label="ປະເພດບໍລິການ"
          multiple
          clearable
        />
      </v-col>

      <v-col>
        <v-select
          v-model="selectedFavoriteDate"
          outlined
          dense
          :items="favorite_dates"
          item-text="name"
          item-value="name"
          label="ມື້ບໍລິການ"
          multiple
        />
      </v-col>
      <v-col>
        <SaleAdmin
          v-model="selectedSale"
          label="ເລືອກຜູ້ສ້າງ"
        />
      </v-col>
      <v-col>
        <v-text-field
          v-model="search"
          outlined
          dense
          clearable
          prepend-inner-icon="mdi-magnify"
          label="ຄົ້ນຫາ"
          type="text"
          @keyup.enter="Search()"
        />
      </v-col>
      <v-col>
        <v-checkbox
          v-model="noProfileOnly"
          class="mt-1"
          dense
          hide-details
          color="warning"
          label="No service profile"
        />
      </v-col>
    </v-row>
    <div>
      <v-card>
        <v-card-title>
          <template v-if="noProfileOnly">
            No service profile ({{ customers.length }})
          </template>
          <template v-else>
            ຂໍ້ມູນຫົວໜ່ວຍທຸລະກິດ ({{ pagination.total }})
          </template>
          <v-divider
            class="mx-4"
            vertical
          />
          <span
            v-if="noProfileOnly && noProfileFetch.pages"
            class="text-caption grey--text"
          >
            all {{ noProfileFetch.pages }} pages · {{ noProfileFetch.scanned }} companies scanned
          </span>
          <v-spacer />
          <v-btn
            v-if="noProfileOnly"
            color="warning"
            outlined
            :disabled="!customers.length"
            @click="exportWorklist()"
          >
            <v-icon left>
              mdi-download
            </v-icon>
            Export worklist
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-data-table
            :headers="headers"
            :items="customers"
            :search="search"
            :disable-pagination="true"
            hide-default-footer
          >
            <template v-slot:item.media="{ item }">
              <v-avatar
                v-for="(img, index) in item.media"
                :key="index"
                size="36px"
              >
                <img
                  v-if="img.url"
                  :src="img.url"
                >
              </v-avatar>
            </template>
            <template v-slot:item.status="{ item }">
              <v-chip
                :color="customerStatusColor(item.status)"
                label
                @click="switchStatus(item.id)"
              >
                {{ item.status }}
              </v-chip>
            </template>
            <template v-slot:item.village_detail="{ item }">
              <div
                v-for="(data, index) in item.village_details"
                :key="index"
              >
                <div>{{ data.name }}</div>
              </div>
            </template>
            <template v-slot:item.favorite_dates="{ item }">
              <div
                v-for="(data, index) in item.favorite_dates"
                :key="index"
              >
                <div>{{ data.name }}</div>
              </div>
            </template>

            <template v-slot:item.cost_by="{ item }">
              <div>{{ costBy(item.cost_by) }}</div>
            </template>
            <template v-slot:item.price="{ item }">
              <div v-if="item.cost_by !== 'bag'">
                {{ Intl.NumberFormat().format(item.fix_cost) }}
              </div>
              <div v-if="item.cost_by == 'bag'">
                <div
                  v-if="item.current_bag_price"
                >
                  {{ Intl.NumberFormat().format(item.current_bag_price.price) }}
                </div>
              </div>
            </template>

            <template v-slot:item.expect_trash="{ item }">
              <v-chip
                v-if="item.expect_trash"
                outlined
                color="green"
              >
                {{ Intl.NumberFormat().format(item.expect_trash) }}
                {{ getCustomerUnitFunc(item.cost_by) }}
              </v-chip>
              <v-chip
                v-else-if="isWorklistCompany(item)"
                class="no-service-profile-marker"
                small
                label
                color="warning"
              >
                No service profile
              </v-chip>
              <div v-else>
                -
              </div>
            </template>

            <template v-slot:item.current_month_info="{ item }">
              <v-chip
                v-if="item.current_month_info"
                outlined
                :color="getTrashColor(item, getTrash(item.cost_by, item.last_month_info))"
              >
                {{
                  Intl.NumberFormat().format(getTrash(item.cost_by, item.current_month_info)) }}
                {{ getCustomerUnitFunc(item.cost_by) }}
              </v-chip>
              <div v-else>
                -
              </div>
            </template>

            <template v-slot:item.last_month_info="{ item }">
              <v-chip
                v-if="item.last_month_info"
                dark
                :color="getTrashColor(item, getTrash(item.cost_by, item.last_month_info))"
              >
                {{
                  Intl.NumberFormat().format(getTrash(item.cost_by, item.last_month_info)) }}
                {{ getCustomerUnitFunc(item.cost_by) }}
              </v-chip>
              <div v-else>
                -
              </div>
            </template>

            <template v-slot:item.can_collect="{ item }">
              <v-chip :color="statusColor(item.can_collect)">
                {{ CanCollect(item.can_collect) }}
              </v-chip>
            </template>

            <template v-slot:item.created_at="{ item }">
              <div>{{ moment(item.created_at).format("DD-MM-YY") }}</div>
            </template>

            <template v-slot:item.actions="{ item }">
              <v-menu offset-y>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    color="primary"
                    dark
                    v-bind="attrs"
                    medium
                    class="mr-2"
                    v-on="on"
                  >
                    mdi-dots-vertical
                  </v-icon>
                </template>
                <v-list>
                  <v-list-item
                    v-if="$can(['update_customer','update_customer_company'])"
                    link
                    @click="addUser(item)"
                  >
                    <v-list-item-title>
                      <v-icon
                        small
                        class="mr-2"
                      >
                        mdi-plus
                      </v-icon>ເພີ່ມຜູ້ປະສານງານ
                    </v-list-item-title>
                  </v-list-item>
                  <v-list-item
                    link
                    @click="viewPage(item.id)"
                  >
                    <v-list-item-title>
                      <v-icon
                        small
                        class="mr-2"
                      >
                        mdi-eye
                      </v-icon>ລາຍລະອຽດ
                    </v-list-item-title>
                  </v-list-item>
                  <v-list-item
                    v-if="$can(['update_customer','update_customer_company'])"
                    link
                    @click="editPage(item.id)"
                  >
                    <v-list-item-title>
                      <v-icon
                        small
                        class="mr-2"
                      >
                        mdi-pencil
                      </v-icon>ແກ້ໄຂ
                    </v-list-item-title>
                  </v-list-item>
                  <v-list-item
                    v-if="$can(['update_customer','update_customer_company'])"
                    link
                    @click="deleteItem(item.id)"
                  >
                    <v-list-item-title>
                      <v-icon small>
                        mdi-delete
                      </v-icon>ລຶບ
                    </v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </template>
          </v-data-table>
          <br>
          <template>
            <Pagination
              v-if="!noProfileOnly && pagination.total_pages > 1"
              :pagination="pagination"
              :offset="offset"
              @paginate="fetchData()"
            />
          </template>
        </v-card-text>
      </v-card>
    </div>

    <!-- Modal Add-->
    <ModalAdd>
      <template @close="close">
        <v-card>
          <v-card-title>
            <p>ເພີ່ມຜູ້ປະສານງານ</p>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-form
                ref="form"
                lazy-validation
              >
                <v-row>
                  <v-col cols="12">
                    <v-text-field
                      v-model="user.name"
                      label="Name *"
                      required
                    />
                    <p class="errors">
                      {{ server_errors.name }}
                    </p>
                  </v-col>
                  <v-col cols="12">
                    <v-text-field
                      v-model="user.surname"
                      label="Surname *"
                      required
                    />
                    <p class="errors">
                      {{ server_errors.surname }}
                    </p>
                  </v-col>
                  <v-col cols="12">
                    <v-text-field
                      v-model="user.phone"
                      label="ເບີໂທ *"
                      required
                      type="number"
                      class="input-number"
                    />
                    <p class="errors">
                      {{ server_errors.phone }}
                    </p>
                  </v-col>
                </v-row>
              </v-form>
            </v-container>
            <v-card-actions>
              <v-spacer />
              <v-btn
                color="blue darken-1"
                text
                @click="closeAddModal()"
              >
                Close
              </v-btn>
              <v-btn
                color="blue darken-1"
                text
                :loading="loading"
                :disabled="loading"
                @click="AddItem()"
              >
                Save
              </v-btn>
            </v-card-actions>
          </v-card-text>
        </v-card>
      </template>
    </ModalAdd>

    <!--Delete Modal-->
    <ModalDelete>
      <template>
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="blue darken-1"
            text
            @click="closeDelete"
          >
            Cancel
          </v-btn>
          <v-btn
            color="blue darken-1"
            text
            :loading="loading"
            :disabled="loading"
            @click="deleteItemConfirm"
          >
            OK
          </v-btn>
          <v-spacer />
        </v-card-actions>
      </template>
    </ModalDelete>
  </v-container>
</template>

<script>
import { GetOldValueOnInput } from '@/Helpers/GetValue';
import { getCustomerUnit } from '@/Helpers/Customer';
import moment from 'moment';
import queryOption from '@/Helpers/queryOption';
import SaleAdmin from '@/components/select/SaleAdmin.vue';
import { isWorklistCompany, LIVE_STATUSES, toWorklistCsv } from '@/utils/serviceProfile.mjs';

export default {
  name: 'Customer',
  components: {
    SaleAdmin,
  },
  title() {
    return `Vientiane Waste Co-Dev|${this.title}`;
  },
  data() {
    return {
      title: 'Company',
      start_date: '',
      end_date: '',
      start_menu: false,
      end_menu: false,

      customers: [],
      loading: false,
      customerId: '',
      // Pagination
      offset: 12,
      pagination: {},
      per_page: 100,
      // "No service profile" filter: fetches every page, then filters client-side.
      noProfileOnly: false,
      noProfilePageSize: 500,
      noProfileRun: 0,
      noProfileFetch: { pages: 0, scanned: 0, ms: 0 },
      search: '',
      oldVal: '',
      // Add Package
      // start_date: "",
      // start_menu: false,
      // allowedDates: (val) => new Date(val).getDate() === 1,
      packages: [],
      selectedPackage: '',
      start_collect: false,
      server_errors: {},
      // Filter
      districts: [],
      selectedDistrict: '',
      villages: [],
      selectedVillage: [],
      selectedStatus: [],
      status: [
        {
          id: 1,
          name: 'active',
        },
        {
          id: 2,
          name: 'inactive',
        },
        {
          id: 3,
          name: 'trial',
        },
      ],
      selectedCanCollect: '',
      can_collects: [
        {
          id: 1,
          name: 'ເກັບໄດ້',
          value: '1',
        },
        {
          id: 2,
          name: 'ເກັບບໍໄດ້',
          value: '0',
        },
      ],
      selectedCustomerStatus: [],
      customerStatus: [
        {
          id: 1,
          value: 'no_calendar',
          name: 'ມີແຜນເດີນລົດເກັບ',
        },
        {
          id: 2,
          value: 'calendar',
          name: 'ຍັງບໍ່ມີແຜນເດີນລົດເກັບ',
        },
        {
          id: 3,
          value: 'no_route_plan',
          name: 'ມີເສັ້ນທາງເກັບຂີ້ເຫື້ຍອ',
        },
        {
          id: 4,
          value: 'route_plan',
          name: 'ຍັງບໍ່ມີເສັ້ນທາງເກັບຂີ້ເຫື້ຍອ',
        },
      ],
      selectedCost: [],
      costs: [
        {
          id: 1,
          value: 'container',
          name: 'ຄອນເທັນເນີ',
        },
        {
          id: 2,
          value: 'fix_cost',
          name: 'ທຸລະກິດເປັນຖ້ຽວ',
        },
        {
          id: 3,
          value: 'chartered',
          name: 'ມອບເໝົາ',
        },
        {
          id: 4,
          value: 'bag',
          name: 'ບໍລິມາດ',
        },
        {
          id: 5,
          value: '32km',
          name: 'ຫຼັກ32',
        },
        {
          id: 6,
          value: 'infect',
          name: 'ຂີ້ເຫຍື້ອຕິດເຊື້ອ',
        },
      ],
      user: {},
      item: {},
      selectedSale: '',
      favorite_dates: [],
      selectedFavoriteDate: [],
      headers: [
        { text: 'ລະຫັດ', value: 'customer_id', width: '150px' },
        { text: 'ບໍລິສັດ', value: 'company_name', width: '150px' },
        { text: 'ເບີໂທ', value: 'user.phone', width: '100px' },
        {
          text: 'ບ້ານ',
          value: 'village.name',
          sortable: false,
          width: '150px',
        },
        {
          text: 'ເມືອງ',
          value: 'district.name',
          sortable: false,
          width: '100px',
        },
        {
          text: 'ລາຍລະອຽດທີ່ຢູ່',
          value: 'village_detail',
          sortable: false,
          width: '200px',
        },
        { text: 'ປະເພດບໍລິການ', value: 'cost_by_la', width: '200px' },
        { text: 'ມູນຄ່າສັນຍາ', value: 'price', width: '150px' },
        { text: 'ຂີ້ເຫຍື້ອຄາດໝາຍ', value: 'expect_trash', width: '200px' },
        {
          text: 'ຂີ້ເຫຍື້ອປັດຈຸບັນ',
          value: 'current_month_info',
          width: '200px',
        },
        {
          text: 'ຂີ້ເຫຍື້ອເດືອນກ່ອນ',
          value: 'last_month_info',
          width: '200px',
        },
        {
          text: 'ສະຖານະເກັບ',
          value: 'can_collect',
          align: 'center',
          width: '100px',
        },
        { text: 'ສະຖານະອອກບິນ', value: 'status', width: '200px' },

        { text: 'ມື້ບໍລິການ', value: 'favorite_dates', width: '120px' },
        {
          text: 'ໝາຍເຫດ',
          value: 'collect_description',
          sortable: false,
          width: '200px',
        },
        {
          text: 'ວັນທີສ້າງ',
          value: 'created_at',
          width: '150px',
          sortable: false,
        },
        {
          text: 'ຜູ້ສ້າງ',
          value: 'customer_activity.causer.name',
          width: '150px',
          sortable: false,
        },
        { text: '', value: 'media' },
        { text: '', value: 'actions', sortable: false },
      ],
    };
  },
  watch: {
    noProfileOnly() {
      this.pagination.current_page = '';
      this.fetchData();
    },
    selectedFavoriteDate() {
      this.pagination.current_page = '';
      this.fetchData();
    },
    start_date() {
      this.server_errors.start_month = '';
      this.pagination.current_page = '';
      if (this.end_date != '') {
        if (this.start_date > this.end_date) {
          this.start_date = '';
        }
      }
      this.fetchData();
    },
    end_date() {
      this.pagination.current_page = '';
      if (this.end_date < this.start_date) {
        this.end_date = '';
      }
      this.fetchData();
    },
    search(value) {
      this.pagination.current_page = '';
      if (value == '') {
        this.fetchData();
      }
    },
    selectedVillage() {
      this.pagination.current_page = '';
      this.fetchData();
    },
    selectedDistrict() {
      this.pagination.current_page = '';
      this.fetchVillage();
      this.fetchData();
    },
    selectedStatus() {
      this.pagination.current_page = '';
      this.fetchData();
    },
    selectedPackage() {
      this.server_errors.package_id = '';
    },

    selectedCustomerStatus() {
      this.pagination.current_page = '';
      this.fetchData();
    },
    selectedCost() {
      this.pagination.current_page = '';
      this.fetchData();
    },
    selectedCanCollect() {
      this.pagination.current_page = '';
      this.fetchData();
    },
    selectedSale() {
      this.pagination.current_page = '';
      this.fetchData();
    },
    'user.name': function () {
      this.server_errors.name = '';
    },
    'user.surname': function () {
      this.server_errors.name = '';
    },
    'user.phone': function () {
      this.server_errors.phone = '';
    },
  },
  created() {
    this.fetchData();
    this.fetchAddress();
    this.fetchFavorite();
  },
  methods: {
    moment,
    customerStatusColor(value) {
      if (value == 'active') return 'primary';
      if (value == 'inactive') return 'error';
      return 'info';
    },
    switchStatus(id) {
      this.$store.commit('Loading_State', true);
      this.$axios
        .post(`customer/${id}/switch-status`)
        .then((res) => {
          if (res.data.code == 200) {
            setTimeout(() => {
              this.$store.commit('Loading_State', false);
              this.fetchData();
              this.$store.commit('Toast_State', {
                value: true,
                color: 'success',
                msg: res.data.message,
              });
            }, 300);
          }
        })
        .catch((error) => {
          this.$store.commit('Loading_State', false);
          this.$store.commit('Toast_State', {
            value: true,
            color: 'error',
            msg: error.response
              ? error.response.data.message
              : 'Something went wrong',
          });
        });
    },

    getTrashColor(item, amount) {
      if (!item.expect_trash || item.expect_trash > amount) return 'blue';

      if (item.expect_trash == amount) return 'green';

      return 'red';
    },
    getCustomerUnitFunc(costBy) {
      return getCustomerUnit(costBy);
    },
    getTrash(costBy, info) {
      if (!info) return 0;
      switch (costBy) {
        case 'bag':
        case 'chartered':
        case 'infect':
        case '32km':
          return info.bag_sum;
        case 'container':
          return info.container_sum;
        case 'fix_cost':
          return info.count_time;
        default:
          return costBy;
      }
    },
    filterParams(page, perPage, statuses) {
      return queryOption([
        { page },
        { per_page: perPage },
        { filter: this.search },
        { date_from: this.start_date },
        { date_end: this.end_date },
        { statuses },
        { without: this.selectedCustomerStatus },
        { villages: this.selectedVillage },
        { can_collect: this.selectedCanCollect },
        { district_id: this.selectedDistrict },
        { cost_by: this.selectedCost },
        { favorite_dates: this.selectedFavoriteDate },
        { created_by_id: this.selectedSale },
      ]);
    },
    fetchData() {
      if (this.noProfileOnly) {
        this.fetchAllNoProfile();
        return;
      }
      this.noProfileRun += 1;
      const run = this.noProfileRun;
      this.$store.commit('Loading_State', true);
      this.$axios
        .get('company', {
          params: this.filterParams(this.pagination.current_page, this.per_page, this.selectedStatus),
        })
        .then((res) => {
          if (run !== this.noProfileRun) return;
          if (res.data.code == 200) {
            this.$store.commit('Loading_State', false);
            this.customers = res.data.data.data;
            this.pagination = res.data.data.pagination;
          }
        })
        .catch((error) => {
          this.$store.commit('Loading_State', false);
          if (error.response && error.response.status == 422) {
            const obj = error.response.data.errors || error.response.data.data || {};
            for (const [key, message] of Object.entries(obj)) {
              this.server_errors[key] = Array.isArray(message) ? message[0] : message;
            }
          }
        });
    },

    // The API filters only by name and paginates, so a page-only filter would miss rows.
    // Walk every page (other filters still apply server-side), keep the live no-profile rows.
    async fetchAllNoProfile() {
      this.noProfileRun += 1;
      const run = this.noProfileRun;
      const started = Date.now();
      // Only live statuses can be on the worklist; ask the server for those alone.
      const statuses = this.selectedStatus.length
        ? this.selectedStatus.filter((s) => LIVE_STATUSES.includes(s))
        : LIVE_STATUSES;
      this.$store.commit('Loading_State', true);
      const rows = [];
      let page = 1;
      let totalPages = 1;
      let scanned = 0;
      try {
        if (statuses.length) {
          do {
            // eslint-disable-next-line no-await-in-loop
            const res = await this.$axios.get('company', {
              params: this.filterParams(page, this.noProfilePageSize, statuses),
            });
            if (run !== this.noProfileRun) return;
            const data = res.data.data;
            scanned += data.data.length;
            rows.push(...data.data.filter(isWorklistCompany));
            totalPages = (data.pagination && data.pagination.total_pages) || 1;
            page += 1;
          } while (page <= totalPages);
        }
        this.customers = rows;
        this.noProfileFetch = {
          pages: statuses.length ? totalPages : 0,
          scanned,
          ms: Date.now() - started,
        };
      } catch (error) {
        if (run !== this.noProfileRun) return;
        this.customers = [];
        this.noProfileFetch = { pages: 0, scanned: 0, ms: 0 };
        this.$store.commit('Toast_State', {
          value: true,
          color: 'error',
          msg: error.response ? error.response.data.message : 'Something went wrong',
        });
      } finally {
        if (run === this.noProfileRun) this.$store.commit('Loading_State', false);
      }
    },
    isWorklistCompany,
    exportWorklist() {
      const blob = new Blob([toWorklistCsv(this.customers)], { type: 'text/csv;charset=utf-8' });
      const url = URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = `no-service-profile-worklist-${moment().format('YYYY-MM-DD')}.csv`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
    },

    fetchAddress() {
      this.$axios
        .get('info/address', { params: { filter: 'ນະຄອນຫລວງວຽງຈັນ' } })
        .then((res) => {
          if (res.data.code == 200) {
            this.address = res.data.data;
            this.address.map((item) => {
              this.districts = item.districts;
            });
          }
        })
        .catch(() => {});
    },

    fetchVillage() {
      this.$axios
        .get(`info/district/${this.selectedDistrict}/village`)
        .then((res) => {
          if (res.data.code == 200) {
            this.villages = res.data.data;
          }
        })
        .catch(() => {});
    },

    closeDelete() {
      this.$store.commit('modalDelete_State', false);
    },
    deleteItem(id) {
      this.customerId = id;
      this.$store.commit('modalDelete_State', true);
    },

    deleteItemConfirm() {
      this.$store.commit('Loading_State', true);
      this.$axios
        .delete(`company/${this.customerId}`)
        .then((res) => {
          if (res.data.code == 200) {
            setTimeout(() => {
              this.$store.commit('Loading_State', false);
              this.$store.commit('modalDelete_State', false);
              this.fetchData();
              this.$store.commit('Toast_State', {
                value: true,
                color: 'success',
                msg: res.data.message,
              });
            }, 300);
          }
        })
        .catch((error) => {
          this.fetchData();
          this.$store.commit('Toast_State', {
            value: true,
            color: 'error',
            msg: error.response
              ? error.response.data.message
              : 'Something went wrong',
          });
          this.$store.commit('modalDelete_State', false);
          this.$store.commit('Loading_State', false);
        });
    },
    addUser(data) {
      this.item = data;
      this.$store.commit('modalAdd_State', true);
    },
    closeAddModal() {
      this.$store.commit('modalAdd_State', false);
    },
    AddItem() {
      if (this.$refs.form.validate() == true) {
        this.$store.commit('Loading_State', true);
        this.$axios
          .post(`company/${this.item.id}/coordinator`, this.user)
          .then((res) => {
            if (res.data.code == 200) {
              setTimeout(() => {
                this.$store.commit('Loading_State', false);
                this.closeAddModal();
                this.user = {};
                this.fetchData();
                this.reset();
                this.$store.commit('Toast_State', {
                  value: true,
                  color: 'success',
                  msg: res.data.message,
                });
              }, 300);
            }
          })
          .catch((error) => {
            this.$store.commit('Loading_State', false);
            this.$store.commit('Toast_State', {
              value: true,
              color: 'error',
              msg: error.response
                ? error.response.data.message
                : 'Something went wrong',
            });
            this.fetchData();
            if (error.response && error.response.status == 422) {
              const obj = error.response.data.errors || error.response.data.data || {};
              const errMsg = {};
              for (const [key, customer] of Object.entries(obj)) {
                errMsg[key] = Array.isArray(customer) ? customer[0] : customer;
              }
              this.server_errors = errMsg;
            }
          });
      }
    },
    reset() {
      this.$refs.form.reset();
    },

    createPage() {
      this.$router.push({
        name: 'CreateCompany',
      });
    },
    editPage(id) {
      this.$router.push({
        name: 'EditCompany',
        params: { id },
      });
    },
    viewPage(id) {
      const route = this.$router.resolve({
        name: 'ViewCompanyDetail',
        params: { id },
      });

      window.open(route.href);
    },
    Search() {
      GetOldValueOnInput(this);
    },
    statusColor(value) {
      if (value == '1') return 'success';
      if (value == '0') return 'error';
      return 'info';
    },
    CanCollect(value) {
      if (value == '1') return 'ເກັບໄດ້';
      if (value == '0') return 'ເກັບບໍ່ໄດ້';
    },

    costBy(value) {
      if (value == 'container') return 'ຄອນເທັນເນີ';
      if (value == 'fix_cost') return 'ທຸລະກິດເປັນຖ້ຽວ';
      if (value == 'chartered') return 'ມອບເໝົາ';
      if (value == 'bag') return 'ບໍລິມາດ';
      if (value == 'infect') return 'ຂີ້ເຫຍື້ອຕິດເຊື້ອ';
      if (value == '32km') return 'ຫຼັກ32';
      return value;
    },
    fetchFavorite() {
      this.$axios
        .get('favorite-date')
        .then((res) => {
          if (res.data.code == 200) {
            setTimeout(() => {
              this.favorite_dates = res.data.data;
            }, 100);
          }
        })
        .catch(() => {});
    },
  },
};
</script>

<style lang="scss">
@import "../../../public/scss/main.scss";
</style>
